<script setup lang="ts">
import UserAvatar from '@/components/user-avatar/UserAvatar.vue';
import { computed } from 'vue';
import { useSessionStore } from '@/stores/session.ts';

interface SessionParticipantInfoCardProps {
    userId?: string;
}

const sessionStore = useSessionStore();
const props = defineProps<SessionParticipantInfoCardProps>();

const user = computed(() => {
    return sessionStore.participants.find((p) => p.id === props.userId);
});
const status = computed(() => {
    const type = user.value?.role === 'voter' ? 'Voter |' : 'Observer';
    const state = user.value?.vote ? 'Voted' : 'Pending';
    return `${type} ${user.value?.role === 'voter' ? state : ''}`;
});
</script>

<template>
    <div class="p-2 flex items-center gap-2" v-if="user">
        <UserAvatar :participant="user" />
        <div class="flex flex-col gap-0.5 paragraph-xs">
            <span class="text-foreground-primary font-bold">{{ user?.name }}</span>
            <span class="text-foreground-muted">{{ status }}</span>
        </div>
    </div>
</template>
